export default __webpack_public_path__ + "static/airdrop-pool-80461a2ef0cc2aeaedf9b82516ec1ecf.webp";